Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ethjsUnit = require('ethjs-unit');

var _ethjsUnit2 = _interopRequireDefault(_ethjsUnit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _ethjsUnit2['default'].toWei;
module.exports = exports['default'];
//# sourceMappingURL=toWei.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ethtools/build/toWei.js
// module id = +Nh2
// module chunks = 0